import { ContentCopy, Delete } from "@mui/icons-material";
export const AdminControls = ({
  isSelected,
  onCopy,
  onDelete,
  onResizeMouseDown,
  boxId,
}) => {
  if (!isSelected) return null;

  return (
    <>
      <div className="resize-handle" onMouseDown={onResizeMouseDown} />
      <div className="action-buttons">
        <button
          onClick={(e) => {
            e.stopPropagation();
            onCopy(boxId);
          }}
          className="action-btn copy-btn"
          title="Copy"
        >
          <ContentCopy className="action-icon" />
        </button>
        <button
          onClick={(e) => {
            e.stopPropagation();
            onDelete(boxId);
          }}
          className="action-btn delete-btn"
          title="Delete"
        >
          <Delete className="action-icon" />
        </button>
      </div>
    </>
  );
};

export const PreviewBox = ({ previewBox }) => {
  if (!previewBox) return null;

  return (
    <div
      className="preview-box"
      style={{
        position: "absolute",
        left: `${previewBox.x}%`,
        top: `${previewBox.y}%`,
        width: `${previewBox.width}%`,
        height: `${previewBox.height}%`,
        zIndex: 20,
      }}
    />
  );
};
